<template>
  <div class="public-header-modular">
    <div class="header-top-modualr">
      <div class="header-center-modualr">
        <div class="left-item-modular">
          <div class="left-item">
            <!-- <span>USD</span>
            <img
              class="down-arrow-icon"
              src="../../assets/public/down-arrow-icon.png"
              alt=""
            /> -->
            <div class="currency-list-modualr">
              <el-dropdown
                trigger="click"
                @command="currencyChange()"
                @visible-change="changeCurrencyDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currCurrency }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="currencyDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in rateList"
                    :key="index"
                    >{{ item.currency_name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="left-item">
            <!-- <span>中文简体</span>
            <img
              class="down-arrow-icon"
              src="../../assets/public/down-arrow-icon.png"
              alt=""
            /> -->
            <div class="language-category-modular">
              <el-dropdown
                trigger="click"
                @command="languageChange"
                @visible-change="changeLanguageDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currLanguage }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="languageDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in languageList"
                    :key="index"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="right-item-modualr">
          <!-- <div
            class="right-item"
            @click="toshoppingcart()"
            style="cursor: pointer"
          >
            <img
              class="shop-cart-icon"
              v-if="shopCartNum == 0"
              src="../../assets/public/shopping-cart-icon.png"
              alt=""
            />
            <el-badge :value="shopCartNum" class="item" v-else>
              <img
                class="shop-cart-icon"
                src="../../assets/public/shopping-cart-icon.png"
                alt=""
              />
            </el-badge>
            <span class="shop-cart-text">{{ pageText.shoppingcart }}</span>
          </div> -->
          <div class="right-item" v-if="isLogin" @click="toPersonalCenter()">
            <img class="user-portrait-icon" :src="userInfo.face" alt="" />
            <span class="userName">{{ userInfo.userName }}</span>
            <img
              class="select-icon"
              src="../../assets/public/up-arrow-icon.png"
              alt=""
            />
          </div>
          <!-- <div class="right-item" v-else @click="toLogin()">
            <img
              class="user-portrait-icon"
              src="../../assets/public/portrait-icon.png"
              alt=""
            />
            <span class="user-portrait-text">{{
              pageText.loginorrefisterText
            }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header",
  data() {
    return {
      // 货币 -汇率
      rateList: [],
      //  / 预览列表
      languageList: [],
      isShowTar: true,
      currLanguageId: 0,
      currCurrency: "USD", //货币种类
      currLanguage: "简体中文", //语言种类
      currencyDropdownshow: false, //货币下拉选择
      languageDropdownshow: false, //语言下拉选择
      userCenterDropdownshow: false, //语言下拉选择
      shopCartNum: 0, //localStorage.getItem("cartCount"), //购物车数量
      activeIndex2: "1",
      isLogin: false,
      userInfo: {
        userName: "本杰明",
        face: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469",
        email: "jinxiahce@foxmail.com",
        company: "江苏爱察信息技术有限公司",
      },
      pageText: {
        shoppingcart: "购物车",
        loginorrefisterText: "登录/注册",
      },
      pageTextArr: [
        '购物车',
        '登录/注册',
        '您还没有登录，请先登录',
        '确定',
    ],
      lastIp: "",
    };
  },
  methods: {
    handleSelect() {},
    toPath(path) {
      this.$router.push({
        path: path,
        // query: { name: '', age: '' }
      });
    },
    /**
     * 购物车
     */
     toshoppingcart() {
      this.$router.push({
          path: "/shoppingcart",
        });
      // if (localStorage.getItem("isLogin") == 1) {
      //   this.$router.push({
      //     path: "/shoppingcart",
      //   });
      // } else {
      //   this.$alert(this.pageTextArr[2], "", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: this.pageTextArr[3],
      //   })
      //     .then(() => {
      //       this.$router.push({
      //         path: "/login",
      //       });
      //     })
      //     .catch((action) => {
      //     });
      // }
    },

    // 个人中心
    toPersonalCenter() {
      this.$router.push({
        path: "/personalCenter",
        // query: { name: '', age: '' }
      });
    },
    toLogin() {
      window.localStorage.clear();
      // window.localStorage.removeItem('userInfo');

      this.$router.push({
        path: "/login",
      });
    },
    /**
     * 汇率列表
     */
    getRateList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      // 判断是否已经有语言存在
      //
      if (
        localStorage.getItem("currencyName") != null ||
        localStorage.getItem("currencySymbol") != null ||
        localStorage.getItem("currencyRate") != null
      ) {
        that.rateList = JSON.parse(localStorage.getItem("rateList"));
        that.currCurrency = localStorage.getItem("currencyName");
        return;
      }
      this.$http.getRateList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.rateList = res.data;
            if(!localStorage.getItem("exchangeRateId")){
              localStorage.setItem("exchangeRateId", that.rateList[0].id);
              localStorage.setItem(
                "currencyName",
                that.rateList[0].currency_name
              );
              localStorage.setItem(
                "currencySymbol",
                that.rateList[0].currency_symbol
              );
              localStorage.setItem(
                "currencyRate",
                that.rateList[0].exchange_rate
              );
              that.currCurrency = that.rateList[0].currency_name;
            }else{
              that.currCurrency =  localStorage.getItem(
                "currencyName"
              );;
            }
            localStorage.setItem("rateList", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 货币下拉选择
     * @param {*} command
     */
    currencyChange(command) {
      // command - 下标index
      let that = this;
      that.currCurrency = that.rateList[command].currency_name;
      // 更改汇率-刷新
      if (that.rateList[command].id != localStorage.getItem("exchangeRateId")) {
        this.$parent.$parent.reload();
      }
      localStorage.setItem("exchangeRateId", that.rateList[command].id);
      localStorage.setItem(
        "currencyName",
        that.rateList[command].currency_name
      );
      localStorage.setItem(
        "currencySymbol",
        that.rateList[command].currency_symbol
      );
      localStorage.setItem(
        "currencyRate",
        that.rateList[command].exchange_rate
      );
    },

    /**
     * 货币-显示隐藏
     * @param {*} value
     */
    changeCurrencyDropdownshow(value) {
      this.currencyDropdownshow = value;
    },

    /**
     * 语言下拉框点击
     * @param {*} command
     */
    languageChange(command) {
      // command - 下标index
      let that = this;
      that.currLanguage = that.languageList[command].name;
      let oldLanguage = localStorage.getItem("oldLanguageCode");
      if (oldLanguage == "" || oldLanguage == null) {
        localStorage.setItem(
          "oldLanguageCode",
          that.languageList[command].code
        );
      } else {
        localStorage.setItem("oldLanguageCode", oldLanguage);
      }
      localStorage.setItem("curLanguageCode", that.languageList[command].code);

      localStorage.setItem("curLanguage", that.languageList[command].name);
      localStorage.setItem("curLanguageType", that.languageList[command].id);
      localStorage.setItem("curLanguageIndex", command);
      this.$parent.$parent.reload();
      // vue 国际化 传入语言id
      // this.$parent.$parent.lang_change(that.languageList[command].id)
    },

    /**
     *  语言-显示隐藏
     * @param {*} value
     */
    changeLanguageDropdownshow(value) {
      this.languageDropdownshow = value;
    },

    /**
     * 语言列表
     */
     getLanguageList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      // 判断是否已经有语言存在
      // if (
      //   localStorage.getItem("curLanguage") != null ||
      //   localStorage.getItem("curLanguageType") != null || localStorage.getItem("languageList")!=null
      // ) {
      //   that.languageList = JSON.parse(localStorage.getItem("languageList"));
      //   that.currLanguage = localStorage.getItem("curLanguage");
      //   return;
      // }
      this.$http.getLanguageList(
        data,
        (res) => {
          if (res.ret == 1) {
              that.languageList = res.data;
              if(!localStorage.getItem("curLanguage")){
                localStorage.setItem("curLanguage", that.languageList[0].name);
                localStorage.setItem("curLanguageType", that.languageList[0].id);
                localStorage.setItem("oldLanguageCode", that.languageList[0].code);
                localStorage.setItem("curLanguageCode", that.languageList[0].code);
                localStorage.setItem("curLanguageIndex", 0);
                that.currLanguage=that.languageList[0].name;
              }else{
                that.currLanguage = localStorage.getItem("curLanguage");
              }
              localStorage.setItem("languageList", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 语言翻译-单个词语
     */
    pageTranslate(text) {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + ":" + that.pageText[key] + "&";
      }

      // console.log("transformText",);
      that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面 死数据 -翻译
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      console.log("textArr", textArr);
      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split(":")[0] == key) {
              that.pageText[key] = v.split(":")[1];
            }
          }
        }
      });
    },

    /**
     *
     * 获取本机ip地址
     */
    getUserIP(onNewIP) {
      //获取不到可能是因为chrome浏览器版本过高，需要修改浏览器配置如下

      //在chrome地址栏输入：chrome://flags/#enable-webrtc-hide-local-ips-with-mdns

      // 把 Anonymize local IPs exposed by WebRTC 设置为 disabled

      //不能确保每一个浏览器都设置打开webRTC~~~~~

      console.log("getUserIP-----");
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;

      let pc = new MyPeerConnection({
        iceServers: [],
      });

      let noop = () => {};

      let localIPs = {};

      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      let iterateIP = (ip) => {
        if (!localIPs[ip]) {
          onNewIP(ip);
        }

        localIPs[ip] = true;
      };

      pc.createDataChannel("");

      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) {
              return;
            }

            line.match(ipRegex).forEach(iterateIP);
          });

          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {
          console.log(reason);
        });

      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        ) {
          return;
        }

        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },

    
    getLongitudeLatitude() {
      let that = this;
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 3000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lng = position.coords.longitude //当前位置精度
          console.log(lat,lng)
          let data = {
            longitude: lng,
            dimension: lat,
          };
          that.getAddress(data)
        }
        function error(err) {
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          let data = {
            longitude: '',
            dimension: '',
          };
          that.getAddress(data)
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }

    },
    getAddress(data){
      let that = this;
     
      if(!localStorage.getItem("internalCountry")){
        that.$http.getAddress(
            data,
            (res) => {
              if (res.ret == 1) {
                localStorage.setItem("internalCountry", res.internalCountry);//
                if(res.internalCountry==2){
                  that.languageChange(1);
                }
              }
             
            },
          );
      }
      
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr){
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },
  },
  mounted() {
    let that = this;
    // that.getLongitudeLatitude();

    //汇率
    that.getRateList();
    //语言
    // that.pageTranslate();
    that.getLanguageList();
    // 当前语言
    that.currLanguageId = localStorage.getItem("curLanguageType");
    // 当前汇率
    that.currCurrency = localStorage.getItem("currencyName");
    // 购物车数量
    that.shopCartNum = this.number;
    that.languageTranslateByArrs(that.pageTextArr);

    //   that.getUserIP((ip)=>{
    //   console.log("ip-------",ip);
    // })
    // this.lastIp = localStorage.getItem("cip");
    // console.log("lastIp", this.lastIp);

  },
  props: ["number"],
};
</script>

<style lang="scss">
.public-header-modular {
  width: 100%;

  .header-top-modualr {
    // width: 100%;
    // height: 48px;
    padding: 13px 0px;
    // padding: 13px 8px;
    background: #f6f6f6;

    .header-center-modualr {
      width: 1200px;
      margin: auto;
      height: 100%;
      // line-height: 48px;
      display: flex;
      justify-content: space-between;

      .left-item-modular {
        display: flex;

        .left-item {
          cursor: pointer;
        }

        .left-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }

        .down-arrow-icon {
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .down-arrow-icon2 {
          transform: rotate(180deg);
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .left-item:last-child {
          margin-left: 32px;
        }
      }

      .right-item-modualr {
        display: flex;

        .right-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }

        .right-item {
          .shop-cart-icon,
          .user-portrait-icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            border-radius: 50%;
          }

          .userName {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-right: 2px;
          }

          .select-icon {
            transform: rotate(180deg);
            width: 10px;
            height: 5px;
            vertical-align: middle;
          }
        }

        .right-item:last-child {
          margin-left: 28px;
        }
      }
    }
  }

  // .header-top-tar-modualr {
  //   .el-menu {
  //     display: flex;
  //     justify-content: center;
  //     border-bottom-width: 0px;
  //   }

  //   .el-menu>.is-active {
  //     border-bottom-color: #EC0000 !important;
  //   }

  //   .el-menu--horizontal>.el-menu-item {
  //     float: unset !important;
  //   }
  // }
  .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
}

@media screen and (max-width: 500px) {
  .public-header-modular {
    // padding: 0 10px;

    .header-top-modualr {
      // padding: 13px 5px;
      .header-center-modualr {
        width: 100% !important;
        // display: block !important;
        text-align: center;
        display: flex;

        .left-item-modular {
          justify-content: center;
        }
      }

      .right-item-modualr {
        // margin-top: 10px;
        justify-content: center;

        .shop-cart-text,
        .user-portrait-text {
          display: none;
        }
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/public/headerInfo.vue